import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

import HeaderWrapper from '../../components/Header/wrapper'
import FooterWrapper from '../../components/Footer/wrapper'
import OfferDetailsWrapper from '../../components/OfferDetails/wrapper'
import { Breadcrumb } from '../../components'
import usePWAInstallPrompt from '../../hooks/usePWAInstallPrompt'

import styles from './styles'


const useStyles = createUseStyles(styles)

function OfferTemplate(props) {
  usePWAInstallPrompt()

  const classes = useStyles(props)
  const { data = null, breadcrumb = [] } = props

  return (
    <div className={classes.container}>
      <HeaderWrapper />
      <Breadcrumb
        entries={breadcrumb}
        className={classes.breadcrumb}
      />
      {data && (
        <OfferDetailsWrapper
          {...data}
        />
      )}
      <FooterWrapper />
    </div>
  )
}

OfferTemplate.styles = styles

OfferTemplate.propTypes = {
  // eslint-disable-next-line
  breadcrumb: PropTypes.array,
  classes: PropTypes.objectOf(PropTypes.string),
  data: PropTypes.shape(OfferDetailsWrapper.propTypes),
}

export default OfferTemplate
